import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services/auth/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	private authenticationService = inject(AuthenticationService);

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add auth header with jwt if user is logged in and request is to api url
		const user = this.authenticationService.userValue;
		const isLoggedIn = user && user.token;
		const isApiUrl = request.url.startsWith(environment.apiUrl);
		if (isLoggedIn && isApiUrl) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${user.token}`
				}
			});
		}

		return next.handle(request);
	}
}
